import { render, staticRenderFns } from "./listado-publicaciones.vue?vue&type=template&id=6f701ba6&scoped=true&"
import script from "./listado-publicaciones.vue?vue&type=script&lang=ts&"
export * from "./listado-publicaciones.vue?vue&type=script&lang=ts&"
import style0 from "./listado-publicaciones.vue?vue&type=style&index=0&id=6f701ba6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f701ba6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VMenu,VRow,VSpacer})
